<lib-logo></lib-logo>
<div class="container">
    <!-- <lib-highlight-card [tourId]="'330'"></lib-highlight-card> -->
    <lib-audio-tours></lib-audio-tours>
    <lib-buffer [bufferHeight]="2"></lib-buffer>
    <lib-info-carousel></lib-info-carousel>
    <lib-buffer [bufferHeight]="16"></lib-buffer>
    <lib-games-carousel></lib-games-carousel>
    <lib-buffer [bufferHeight]="16"></lib-buffer>
    <lib-events></lib-events>
    <!-- <lib-site-section-carousel></lib-site-section-carousel>
    <lib-buffer [bufferHeight]="16"></lib-buffer> -->
    <lib-action-group [buttons]="buttons"></lib-action-group>
    <!-- <lib-exhibit-carousel></lib-exhibit-carousel>
    <lib-buffer [bufferHeight]="16"></lib-buffer>
    <lib-ar></lib-ar>
    <lib-buffer [bufferHeight]="12"></lib-buffer>
    <lib-audio-tours></lib-audio-tours>
    <lib-buffer [bufferHeight]="16"></lib-buffer>
    <lib-events></lib-events>
    <lib-buffer [bufferHeight]="12"></lib-buffer>
    <lib-nearby-carousel></lib-nearby-carousel>
    <lib-action-group [buttons]="buttons"></lib-action-group>
    <lib-buffer [bufferHeight]="100"></lib-buffer> -->
    <lib-buffer [bufferHeight]="100"></lib-buffer> 
</div>